<template>
  <v-layout class="dialog-modal back" column fill-height justify-start ma-0>
    <v-toolbar color="primary" dark class="elevation-0 node-create-toolbar">
        <v-toolbar-title v-if="edit" class="no-select">{{ $t('edit document descriptions') }}</v-toolbar-title>
        <v-toolbar-title v-else class="no-select">{{$t('upload documents')}}</v-toolbar-title>
        <v-spacer></v-spacer>
    </v-toolbar>

      <v-layout fill-height column  ma-0>
        <v-flex shrink v-if="fileList" py-2>
          <v-layout row  px-1>
            <v-flex xs1 class="text-xs-left pl-3">
              <span class="caption"> {{$t('type')}} </span>
            </v-flex>
            <v-flex xs5 class="text-xs-left pl-1">
              <span class="caption"> {{$t('filename')}} </span>
            </v-flex>
            <v-flex xs5 class="text-xs-left" px-3>
              <span class="caption"> {{$t('description')}} </span>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-divider></v-divider>

        <v-layout column fill-height ma-0>
          <scroll-area>
            <template slot="body">
              <v-flex xs12 v-for="(file, index) in fileList" :key="index"  px-2>

                <file-upload
                    icon="new"
                    :value="file"
                    :ref="'control-file-upload-' + index"
                    @change="(payload) => onFileChange(payload, file, index)"
                    @delete="onFileDelete(file.id, index)"
                />

              </v-flex>
            </template>
          </scroll-area>
        </v-layout>
      </v-layout>
      <v-divider/>
        <v-flex shrink class="grey lighten-4" pa-2>
          <v-layout row justify-end>
            <v-flex shrink>
              <v-btn :data-testid="$options.name + 'v-btn' + 'close'" color="grey" @click.native="close" active-class small>{{ $t('cancel') }}</v-btn>
              <v-btn :data-testid="$options.name + 'v-btn' + 'onFileStoreUpload'" v-if="newFiles.length" color="primary" small @click.native="onFileStoreUpload">{{ $t('download') }}</v-btn>
              <v-btn :data-testid="$options.name + 'v-btn' + 'onFileStoreUpload'" v-if="!newFiles.length" color="primary" small @click.native="onFileStoreUpload">{{ $t('save') }}</v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
  </v-layout>
</template>

<script lang="ts">
import Vue from 'vue'
import scrollArea from '@/nms/components/partials/scrollarea.vue'
import fileUpload from '@/nms/components/utils/file/upload'

// Типы
interface FileData {
  hash?: string
  description?: string
  [key: string]: any
}

interface CustomFile extends File {
  data?: FileData
  id?: string
  [key: string]: any
}

interface CurrentFilesState {
  files: CustomFile[]
  update: string[]
}

interface FormImportState {
  import: {
    id: string | null
    index: string | null
    data: {
      files: any[]
    }
  }
}

interface UploadProgress {
  loaded: number
  total?: number
  [key: string]: any
}

interface ActiveObject {
  $id?: string
  [key: string]: any
}

export default Vue.extend({
  name: 'FORM_FILE_IMPORT',

  components: {
    fileUpload,
    scrollArea
  },

  props: {
    newFiles: {
      type: Array as () => CustomFile[],
      default: () => []
    },
    files: {
      type: Array as () => CustomFile[],
      default: () => []
    },
    edit: {
      type: Boolean,
      default: () => false
    },
    activeObj: {
      type: Object as () => ActiveObject,
      default: () => ({})
    },
    filetype: {
      type: String,
      default: () => ''
    },
  },

  data(): {
    form: FormImportState
    current: CurrentFilesState
  } {
    return {
      form: {
        import: {
          id: null,
          index: null,
          data: {
            files: [],
          },
        }
      },
      current: {
        files: [],
        update: []
      },
    }
  },

  watch: {
    newFiles(newVal: CustomFile[]): void {
      if (!newVal) return
    }
  },

  computed: {
    fileList(): CustomFile[] {
      return this.current.files
    },

    getData(): ActiveObject {
      return this.activeObj
    },
  },

  created(): void {
    this.current.files = this.$merge([], this.files)
    if (this.newFiles.length) {
      this.onFileAdd(this.newFiles)
    }
  },

  methods: {
    async generateFileHash(file: CustomFile): Promise<string> {
      try {
        const fileInfo = `${file.name}${file.lastModified}${file.size}${file.type}`
        const encoder = new TextEncoder()
        const data = encoder.encode(fileInfo)
        const hash = await crypto.subtle.digest('SHA-256', data)
        return Array.from(new Uint8Array(hash))
          .map(b => b.toString(16).padStart(2, '0'))
          .join('')
      } catch (error: any) {
        throw new Error(`Ошибка генерации хеша: ${error.message}`)
      }
    },

    onFileChange(payload: string, file: CustomFile, index: number): void {
      if (this.current.files[index]?.data) {
        this.current.files[index].data!.description = payload
      }
      if (file.id && !this.current.update.find(item => item === file.id)) {
        this.current.update.push(file.id)
      }
      console.log(this.$options.name, 'onFileChange', 'current.file', index, this.current.files[index]?.data?.description)
    },

    onFileAdd(payload: CustomFile[] | CustomFile): void {
      if (payload && Array.isArray(payload)) {
        payload.forEach(file => {
          if (file instanceof File) {
            this.generateFileHash(file).then(hash => {
              const exists = this.current.files.find(item => item.data?.hash === hash)
              if (!exists) {
                file.data = {
                  hash: hash,
                  description: '',
                }
                this.current.files.push(file)
              } else {
                this.$snotify.warning(`Внимание! Файл ${file.name} уже загружен!`, {
                  timeout: 2000,
                  showProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                })
              }
            })
          }
        })
      }
    },

    onFileDelete(id: string, index: number): void {
      this.$emit('delete', id)
      this.$delete(this.current.files, index)
      this.$store.dispatch('updateObject', this.getData)
      if (!this.current.files.length) {
        this.close()
      }
    },

    async mapFiles(): Promise<CustomFile[]> {
      const mFiles: CustomFile[] = []

      this.current.files.forEach(item => {
        if (!item.data) {
          item.data = {}
        }
        item.data.callback = {
          progress: (fileItem: CustomFile, progress: UploadProgress) => {
            if (progress.loaded < 1000000) return

            const toast = this.$snotify.get('toast-' + fileItem.name)

            if (!toast) {
              this.$snotify.html(
                '<div class="fit"><span class="text-truncate block">' + fileItem.name + '</span></div>' +
                '<div class="caption fit"><span id="toast-progress-text-' + fileItem.name + '" class="text-truncate block">Файл загружен на <span id="toast-progress-value-' + fileItem.name + '">' + progress.loaded + '</span>%</span></div>' +
                '<div role="progressbar" aria-valuemin="0" aria-valuemax="100" class="v-progress-linear mb-0" style="height: 4px;">' +
                '<div class="v-progress-linear__background primary" style="height: 4px; opacity: 0.3; width: 100%;"></div>' +
                '<div class="v-progress-linear__bar">' +
                '<div id="toast-progress-bar-' + fileItem.name + '-determinate" class="v-progress-linear__bar__determinate accent" style="width: ' + progress.loaded + '%;"></div>' +
                '<div id="toast-progress-bar-' + fileItem.name + '-indeterminate" style="display: none" class="v-progress-linear__bar__indeterminate v-progress-linear__bar__indeterminate--active"><div class="v-progress-linear__bar__indeterminate long primary"></div><div class="v-progress-linear__bar__indeterminate short primary"></div></div>' +
                '<div id="toast-progress-bar-' + fileItem.name + '-success" style="display: none" class="v-progress-linear__bar__determinate success" style="width: ' + progress.loaded + '%;"></div>' +
                '</div>' +
                '</div>',
                {
                  id: 'toast-' + fileItem.name,
                  timeout: 0,
                  closeOnClick: true,
                  pauseOnHover: false,
                }
              )
            } else {
              const determinateBar = document.getElementById('toast-progress-bar-' + fileItem.name + '-determinate')
              const valueSpan = document.getElementById('toast-progress-value-' + fileItem.name)
              if (determinateBar) {
                determinateBar.style.width = progress.loaded + '%'
              }
              if (valueSpan) {
                valueSpan.innerText = String(progress.loaded)
              }
              if (progress.loaded === 100) {
                this.$snotify.remove('toast-' + fileItem.name)
              }
            }
          },

          success: (fileItem: CustomFile, response: any) => {
            this.$snotify.html(
              '<div class="fit"><span class="text-truncate block">' + fileItem.name + '</span></div>' +
              '<div class="caption fit"><span id="toast-progress-text-' + fileItem.name + '" class="text-truncate block">Файл загружен на <span id="toast-progress-value-' + fileItem.name + '"></span>100%</span></div>' +
              '<div role="progressbar" aria-valuemin="0" aria-valuemax="100" class="v-progress-linear mb-0" style="height: 4px;">' +
              '<div class="v-progress-linear__background green" style="height: 4px; opacity: 1; width: 100%;"></div>' +
              '<div class="v-progress-linear__bar">' +
              '<div id="toast-progress-bar-' + fileItem.name + '-success" style="display: none" class="v-progress-linear__bar__determinate success" style="width: 100%;"></div>' +
              '</div>' +
              '</div>',
              {
                id: 'toast-success' + fileItem.name,
                timeout: 2000,
                showProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
              }
            )
            setTimeout(() => this.$snotify.remove('toast-' + fileItem.name), 0)
            setTimeout(() => this.$snotify.remove('toast-success' + fileItem.name), 2000)
          },

          warning: (fileItem: CustomFile, message: string) => {
            console.log('upload fail', fileItem, message)
          },

          error: (fileItem: CustomFile, message: string) => {
            console.log('upload fail', fileItem, message)
            this.$snotify.error('Внимание! Файл ' + fileItem.name + ' НЕ загружен!', {
              timeout: 2000,
              showProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
            })
          },
        }
        mFiles.push(item)
      })

      return mFiles
    },

    onFileStoreUpload(): void {
      this.mapFiles().then((files) => {
        console.log(this.$options.name, 'onFileStoreUpload', 'mapFiles', files)
        // console.log(this.$options.name, 'onFileStoreUpload', 'mapFiles instanceof', files[0] instanceof File)
        console.log(this.$options.name, 'onFileStoreUpload', 'this.getData', this.getData)
        // // console.log(this.$options.name, 'onFileStoreUpload', 'this.current.files', this.current.files)
        // console.log(this.$options.name, 'onFileStoreUpload', 'this.current.files instanceof', this.current.files[0] instanceof File )
        

        this.$store.dispatch('file/upload/execute', {
          filetype: this.filetype,
          $id: this.getData.$id,
          list: this.current.files,
          vm: this
        })
        this.$store.dispatch('updateObject', this.getData)
        this.$emit('update')

        if (this.current.update.length) {
          this.onFileUpdate()
        } else {
          this.close()
        }
      })
    },

    async onFileUpdate(): Promise<void> {
      try {
        for (const fileId of this.current.update) {
          await this.$bridge.updateDocument(fileId, { data: { description: this.current.files.find(f => f.id === fileId)?.data?.description } })
        }
        this.$store.dispatch('updateObject', this.getData)
        this.close()
      } catch (err) {
        this.$errorHandler(err)
        console.error('CATCH', this.$options.name, 'onFileUpdate', err)
      }
    },

    async onFileUpload(): Promise<void> {
      const formData: { files: CustomFile[] } = { files: [] }
      this.current.files.forEach(file => {
        formData.files.push(file)
      })

      try {
        const $obj = await this.$bridge.getObjectById(this.getData.$id)
        const u = await $obj.update(formData)

        if (u) {
          this.$store.dispatch('updateObject', this.getData)
          this.$emit('update')
          this.close()
        } else {
          console.log('PAGE_LOCATION', 'onFileUpload', 'smth wrong', u)
        }
      } catch (err) {
        this.$errorHandler(err)
        console.error('CATCH', 'PAGE_LOCATION', 'onFileUpload', err)
      }
    },

    close(): void {
      this.$nextTick(() => {
        this.current.files = []
        this.current.update = []
        this.$emit('close')
      })
    },
  },
})
</script>

<style lang="css" scoped>

.dialog-modal {
  /* background-color: #ffffff */
  /* min-height: 500px;
  max-height: 500px; */
  height: 550px;
}

</style>

<style lang="stylus" scoped>

    .button-file-upload

        position: relative
        box-sizing: border-box

        &_extension

            &_blank

                padding-left: 0;
                border-color: transparent

            &_new

                padding-left: 0;
                border-color: transparent

        &__area

            display: flex
            justify-content: center

            width: 80px
            height: 80px

            border-radius: 50%
            border: 1px solid alpha(#000, .4)

        &__control

            position: relative
            overflow: hidden
            z-index: 2

            cursor: pointer

            &.fiv-icon-blank

                opacity: .4
                transition: opacity .4s

                &:hover

                    opacity: 1

            &.fiv-icon-new

                opacity: .4
                transition: opacity .4s

                &:hover

                    opacity: 1

        &__overlay

            position: absolute

            top: 0
            right: 0
            bottom: 0
            left: 0

            margin-right: -8px

            width: 100%
            /* height */

            background: alpha(#fff, .9)

            opacity: 0
            transition: opacity .4s

            &:hover

                opacity: 1

        &__delete

            cursor: pointer

            margin-right: -16px
            margin-top: -16px

            opacity: .5
            transition: opacity .4s

            &:hover

                opacity: 1

        &__input

            display: block
            position: absolute

            top: 0
            right: 0

            min-width: 100%
            min-height: 100%

            text-align: right

            opacity: 0
            outline: none
            cursor: inherit

        &__name

            display: block /* Fallback for non-webkit */
            max-height: calc(20px * 2) /* Fallback for non-webkit */
            min-height: calc(20px * 2) /* Fallback for non-webkit */
            margin: 0 auto
            font-size: 12px
            line-height: 16px
            -webkit-line-clamp: 3
            -webkit-box-orient: vertical
            overflow: hidden
            text-overflow: ellipsis
            word-break: break-all
            text-align: center;


</style>
